<form [formGroup]="form" (submit)="onSubmit()" class="w-80 mb-10">
  <div class="form-group">
    <label for="due-date">Set Default Due Date</label>
    <input
      id="due-date"
      type="number"
      min="1"
      formControlName="dueDateDays"
      class="form-control"
      placeholder="Set number of days"
    />
  </div>
  <div class="form-action">
    <button
      type="button"
      [disabled]="loading"
      class="lum-button lum-button--secondary mr-2"
      (click)="onClear()"
    >
      Clear
    </button>
    <button
      type="submit"
      [disabled]="loading"
      class="lum-button lum-button--primary"
      >Save</button
    >
  </div>
</form>
